import './tinymce.js';

window.opaccEditor = window.tinymce;